
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Deviceinkolkata() {



  const cardData =
  {
    keyword: 'Patient Warming Devices in Kolkata',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming Devices in Kolkata',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Warming Devices in Kolkata, ensuring effective temperature management for patients during surgeries and critical care. Our Wallabies Warm Care systems are designed to prevent hypothermia by delivering consistent and controlled warming, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our patient warming devices are reliable, easy to use, and built with advanced technology. Choose Pharmacle Health Care for the best warming solutions in Kolkata to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

    "topPlaces": [
  {
    "title": "Patient Warming Devices in Kolkata",
    "description": "Pharmacle Health Care Private Limited provides cutting-edge Patient Warming Devices in Kolkata, ensuring optimal temperature regulation for surgical, ICU, and recovery room patients."
  },
  {
    "title": "Advanced Forced-Air Warming System in Kolkata",
    "description": "Pharmacle Health Care Private Limited offers an Advanced Forced-Air Warming System that delivers precise and uniform heat distribution, reducing the risk of perioperative hypothermia."
  },
  {
    "title": "Portable Patient Warmer for Emergency & Ambulance Use",
    "description": "Pharmacle Health Care Private Limited supplies Portable Patient Warmers in Kolkata, ideal for ambulances, emergency rooms, and field hospitals. These devices ensure mobility without compromising efficiency."
  },
  {
    "title": "Neonatal Patient Warming Equipment in Kolkata",
    "description": "Specially designed for newborns, Pharmacle Health Care Private Limited provides Neonatal Patient Warming Equipment in Kolkata to ensure safe and accurate temperature management in NICUs and pediatric care units."
  },
  {
    "title": "ICU Patient Warming System for Critical Care",
    "description": "Pharmacle Health Care Private Limited offers ICU Patient Warming Systems in Kolkata, essential for critical care settings. These systems help patients maintain normothermia for improved recovery outcomes."
  },
  {
    "title": "Surgical Patient Warming Solutions in Kolkata",
    "description": "Pharmacle Health Care Private Limited delivers Surgical Patient Warming Solutions designed for operating rooms in Kolkata. These systems help maintain stable body temperature throughout surgical procedures."
  },
  {
    "title": "Preoperative & Postoperative Warming System in Kolkata",
    "description": "Pharmacle Health Care Private Limited provides Preoperative & Postoperative Warming Systems in Kolkata, ensuring continuous temperature regulation before and after surgery, aiding recovery and reducing complications."
  },
  {
    "title": "Veterinary Patient Warming Devices in Kolkata",
    "description": "Pharmacle Health Care Private Limited extends its expertise to Veterinary Patient Warming Devices in Kolkata, offering effective temperature control for animals undergoing medical treatments and surgeries."
  },
  {
    "title": "Emergency Hypothermia Prevention System in Kolkata",
    "description": "Pharmacle Health Care Private Limited supplies Emergency Hypothermia Prevention Systems in Kolkata, essential for trauma and emergency care to stabilize patient body temperature quickly and effectively."
  },
  {
    "title": "Single-Use Warming Blankets for Hospitals in Kolkata",
    "description": "Pharmacle Health Care Private Limited provides Single-Use Warming Blankets in Kolkata, compatible with our warming systems, offering a hygienic and safe way to maintain patient warmth in hospitals and clinics."
  }
],


"services": [
    {
        "name": "Patient Thermoregulation System Ahmedabad",
        "description": "Pharmacle Health Care Private Limited offers advanced patient thermoregulation systems in Ahmedabad, designed to maintain a stable body temperature during medical treatments, preventing hypothermia and ensuring patient safety throughout surgeries and recovery."
    },
    {
        "name": "Ahmedabad Patient Warming Devices",
        "description": "We provide high-quality patient warming devices in Ahmedabad, designed to regulate and maintain optimal body temperature during medical procedures. Our devices help prevent hypothermia and improve patient comfort in critical care and recovery."
    },
    {
        "name": "Forced Air Warming Systems Ahmedabad",
        "description": "Pharmacle Health Care offers forced air warming systems in Ahmedabad, providing a reliable solution to maintain patient body temperature during surgeries and post-operative care, ensuring safety and comfort throughout the treatment."
    },
    {
        "name": "Thermoregulation Devices Ahmedabad",
        "description": "We supply thermoregulation devices in Ahmedabad that are essential for temperature management during medical procedures. Our devices effectively regulate body temperature to ensure a stable and safe environment for patients."
    },
    {
        "name": "Patient Warming System Supplier Ahmedabad",
        "description": "Pharmacle Health Care is a trusted supplier of patient warming systems in Ahmedabad, offering high-quality equipment designed to maintain optimal patient body temperature during surgeries, critical care, and recovery."
    },
    {
        "name": "Ahmedabad Medical Warming Equipment",
        "description": "Our medical warming equipment in Ahmedabad is designed to ensure patient safety by regulating body temperature during surgeries and medical procedures. We provide effective solutions for hospitals and healthcare providers to improve patient care."
    },
    {
        "name": "Patient Temperature Management Ahmedabad",
        "description": "Pharmacle Health Care offers patient temperature management solutions in Ahmedabad, including warming systems and thermoregulation devices that help control and stabilize patient body temperature during medical procedures to ensure a safe and comfortable experience."
    }
],
"tableData": [
    ["- Patient Thermoregulation System Ahmedabad", "- Ahmedabad Patient Warming Devices"],
    ["- Forced Air Warming Systems Ahmedabad", "- Thermoregulation Devices Ahmedabad"],
    ["- Patient Warming System Supplier Ahmedabad", "- Ahmedabad Medical Warming Equipment"],
    ["- Patient Temperature Management Ahmedabad"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient warming devices in Kolkata, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across the city."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of patient warming devices in Kolkata, including forced air warming blankets and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring that your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient warming devices are manufactured to the highest standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our equipment provides optimal reliability for continuous use in medical settings throughout Kolkata."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our patient warming devices provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring patients in Kolkata are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warming devices in Kolkata are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We collaborate closely with healthcare providers to ensure our systems meet their specific needs and improve overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient warming devices are designed for easy integration with existing medical systems in Kolkata. Our products can be quickly implemented, ensuring a smooth and efficient experience for healthcare professionals without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Kolkata to help healthcare facilities select the right warming devices for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our patient warming devices are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Kolkata receives the highest level of care."
    }
]







  }


  const faqData = [
    { question: "What are Patient Warming Devices?", answer: "Patient Warming Devices are medical devices designed to regulate and maintain a patient's body temperature during surgeries, medical procedures, or treatments by delivering controlled warm air through blankets or other warming mechanisms." },
    { question: "How do Patient Warming Devices work?", answer: "Patient Warming Devices work by circulating warm air through a specially designed warming blanket, ensuring that the patient remains at a stable and safe body temperature during medical procedures." },
    { question: "Are Patient Warming Devices available in Kolkata?", answer: "Yes, Pharmacle Health Care Private Limited offers Patient Warming Devices in Kolkata, providing healthcare facilities with high-quality temperature regulation solutions." },
    { question: "What are the benefits of using Patient Warming Devices?", answer: "The benefits include preventing hypothermia, reducing surgical complications, enhancing patient comfort, and improving recovery times by maintaining a consistent body temperature during procedures." },
    { question: "How long can the Patient Warming Device maintain a patient’s body temperature?", answer: "The device can maintain the patient’s body temperature for the entire duration of the medical procedure, adjusting as needed to ensure consistent warmth." },
    { question: "Are Patient Warming Devices easy to use?", answer: "Yes, they are designed for ease of use with intuitive controls, allowing healthcare professionals to quickly adjust temperature settings and ensure optimal comfort for the patient." },
    { question: "Can Patient Warming Devices be used for all types of surgeries?", answer: "Yes, they can be used for a variety of surgeries and medical procedures where maintaining normothermia is critical for patient safety." },
    { question: "Are Patient Warming Devices safe for all patients?", answer: "Yes, Patient Warming Devices are safe for most patients, but they should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation." },
    { question: "How can I purchase a Patient Warming Device in Kolkata?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you in purchasing and delivering Patient Warming Devices to healthcare facilities in Kolkata." },
    { question: "Does Pharmacle Health Care provide support for Patient Warming Devices?", answer: "Yes, we offer full support for Patient Warming Devices, including installation, staff training, and ongoing maintenance to ensure the devices continue to function optimally." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using Patient Warming Devices from Pharmacle Health Care in our Kolkata hospital, and they have greatly enhanced patient safety and comfort during surgeries, especially for those undergoing lengthy procedures.',
      name: 'Dr. Anil Roy',
    },
    {
      text: 'The Patient Warming Devices from Pharmacle Health Care are a valuable addition to our Kolkata clinic. The devices are easy to use and have improved our ability to maintain normothermia during medical treatments.',
      name: 'Dr. Swati Ghosh',
    }
  ];
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];




  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warming Devices in Kolkata",
    "description": "Discover advanced Patient Warming Devices in Kolkata for effective patient thermoregulation and temperature control during medical procedures. Our warming solutions ensure patient comfort and safety.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1955"
    }
  };
  

  
  return (
    <div>
  <Helmet>
    <title>Patient Warming Devices in Kolkata | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Discover advanced Patient Warming Devices in Kolkata for effective thermoregulation and temperature control during medical procedures. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warming Devices Kolkata, Kolkata Forced Air Warming Systems, Warming Devices Kolkata, Kolkata Patient Thermoregulation Solutions, Kolkata Medical Warming Devices, Kolkata Patient Temperature Control Devices, Kolkata Surgical Warming Solutions"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/8.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Deviceinkolkata;